import styled, { css } from "styled-components";

const buttonModiffiers = {
  //variant
  green: (theme) => css`
    border: 1px solid transparent;
    color: ${theme.darkTheme.colors.darkBlack};
    background-color: ${theme.darkTheme.colors.green};
    :hover {
      color: ${theme.darkTheme.colors.darkBlack};
      background-color: ${theme.darkTheme.colors.white};
    }
  `,
  white: (theme) => css`
    border: 1px solid transparent;
    color: ${theme.darkTheme.colors.darkBlack};
    background-color: ${theme.darkTheme.colors.white};
    :hover {
      color: ${theme.darkTheme.colors.darkBlack};
      background-color: ${theme.darkTheme.colors.green};
    }
  `,
  transparent: (theme) => css`
    background-color: transparent;
    color: #cccccc;
    border: 1px solid #cccccc;
    :hover {
      color: ${theme.darkTheme.colors.green};
      border-color: ${theme.darkTheme.colors.green};
    }
  `,

  //size
  small: () => css`
    width: 125px;
    padding: 6px 4px 4px;
    text-align: center;
  `,
  full: () => css`
    width: 100%;
    padding: 1em;
  `,
};

export const Button = styled.button`
  ${({ theme, variant, size }) => css`
    color: ${theme.font.color.black};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${theme.spacings.smaller};
    border: none;
    border-radius: 5px;
    outline: inherit;
    font-family: ${theme.font.family.maisonNeue};
    text-transform: uppercase;
    text-align: center;
    cursor: pointer;

    padding: ${theme.spacings.smallest} ${theme.spacings.medium};
    font-weight: ${theme.font.weight.bold};
    font-size: ${theme.font.size.small};

    img {
      padding-bottom: 3px;
    }

    ${variant && buttonModiffiers[variant](theme)};
    ${size && buttonModiffiers[size](theme)};
  `}
`;
